import { gql } from "apollo-boost";

export default gql`
  mutation($productId: ID!) {
    approveProductDesign(productId: $productId)
  }
`;
